<prp-list-search class="mx-1"></prp-list-search>

<div class="scrollbar-wrapper">
  <ng-scrollbar [track]="!(format$ | async) ? 'vertical' : 'horizontal'">
    <div *ngIf="data$ | async as data" [@listAnimation]="data">
      <prp-list-item
        *ngFor="let item of data"
        [format]="item"
        [class.disabled]="item.childs?.length === 0"
      ></prp-list-item>

      <div [@easeInOut]="format$ | async">
        <prp-list-item-expand *ngIf="format$ | async"></prp-list-item-expand>
      </div>
    </div>
  </ng-scrollbar>
</div>
